import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';
import { UserProfile } from '@shared/authentication/interfaces';
import { OrderContainer } from '@shared/states/order.state';
import { SettingsService } from './settings.service';
import { SendStatisticsService, StatisticsContextEnum } from '@api/send-statistics.service';

@Injectable({ providedIn: 'root' })
export class ApiService {
  constructor(
    protected readonly http: HttpClient,
    protected readonly settingsService: SettingsService,
    protected statistics: SendStatisticsService,
  ) {}

  public getOrder(onlyProjects = false): Observable<OrderContainer> {
    return this.http
      .get<OrderContainer>(`${this.settingsService.v2}client/configurator/get-order`, {
        params: { onlyProjects },
      })
      .pipe(catchError((err) => of(null)));
  }

  public resetOrder(hash?: string): Observable<boolean> {
    return this.http
      .get<boolean>(`${this.settingsService.v2}client/configurator/clear-order`, {
        headers: this.statistics.createContextHeaders(
          StatisticsContextEnum.MAIN_BOARD_CONTEXT_MENU,
          hash,
        ),
      })
      .pipe(catchError((err) => of(false)));
  }

  public getProfile(): Observable<UserProfile> {
    return this.http
      .get<UserProfile>(`${this.settingsService.v2}client/configurator/get-profile`)
      .pipe(catchError((err) => of(null)));
  }

  public updateProfile(formData: FormData): Observable<UserProfile> {
    return this.http
      .post<UserProfile>(`${this.settingsService.v2}client/configurator/update-profile`, formData)
      .pipe(catchError((err) => of(null)));
  }

  public deleteAvatar(): Observable<UserProfile> {
    return this.http.get<UserProfile>(
      `${this.settingsService.v2}client/configurator/update-profile-delete-avatar`,
    );
  }

  public downloadFiles(
    url: string,
    hash?: { context: StatisticsContextEnum; hash: string },
  ): Observable<Blob> {
    if (hash) {
      return this.http.get(url, {
        responseType: 'blob',
        headers: this.statistics.createContextHeaders(hash.context, hash.hash),
      });
    }

    return this.http.get(url, {
      responseType: 'blob',
    });
  }
}
